module.exports = __webpack_public_path__ + "img/eng.701ffed4.png";